import React, {useEffect, useRef, useState} from "react";
import {useLoad} from "../../context";
import ApiServices from "../../services/apiServices";
import {agruparPorCategoria} from "../../utils/faqCategorias";
import "./index.css";

function CategoryItems({cat, isOpen, prefix}) {
  const containerRef = useRef(null);
  const innerRef = useRef(null);
  const isFirstRender = useRef(true);
  const onEndRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (onEndRef.current) {
      container.removeEventListener("transitionend", onEndRef.current);
      onEndRef.current = null;
    }

    if (isOpen) {
      const h = innerRef.current.scrollHeight + 20;
      container.style.transition = "none";
      container.style.maxHeight = "0px";
      container.offsetHeight; //eslint-disable-line no-unused-expressions
      container.style.transition = "max-height 0.5s ease-out";
      container.style.maxHeight = h + "px";
      onEndRef.current = () => {
        container.style.maxHeight = "99999px";
      };
      container.addEventListener("transitionend", onEndRef.current, {once: true});
    } else {
      const currentH = container.scrollHeight;
      container.style.transition = "none";
      container.style.maxHeight = currentH + "px";
      container.offsetHeight; //eslint-disable-line no-unused-expressions
      container.style.transition = "max-height 0.4s ease-in";
      container.style.maxHeight = "0px";
    }
  }, [isOpen]);

  return (
    <div
      className="faq-category-items"
      ref={containerRef}
      style={{maxHeight: 0, overflow: "hidden"}}
    >
      <div ref={innerRef}>
        {cat.items.map((e, i) => (
          <div key={i} className="accordion accordion-flush" id={`accordion${prefix}Cat${cat.id}Item${i}`}>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed tituloFaq"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#collapse${prefix}Cat${cat.id}Item${i}`}
                  aria-expanded="false">
                  {e.titulo}
                </button>
              </h2>
              <div
                id={`collapse${prefix}Cat${cat.id}Item${i}`}
                className="accordion-collapse collapse textFaq"
                data-bs-parent={`#accordion${prefix}Cat${cat.id}Item${i}`}>
                <div className="accordion-body faqDeslogado">
                  {e.urlImagem && (
                    <img className="faq-image" src={e.urlImagem} alt={e.titulo} />
                  )}
                  <div dangerouslySetInnerHTML={{__html: e.texto}} />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function FaqDeslogado() {
  const {load, setLoad} = useLoad();
  const [faq, setFaq] = useState([]);
  const [categoriaAberta, setCategoriaAberta] = useState(null);

  async function fnFaq() {
    try {
      setLoad(true);
      let response = await ApiServices.apiGet("faq/de-visitante");
      setFaq(response.data || []);
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  useEffect(() => {
    fnFaq();
  }, []); //eslint-disable-line react-hooks/exhaustive-deps

  const toggleCategoria = (catId) => {
    setCategoriaAberta(categoriaAberta === catId ? null : catId);
  };

  const faqDeslogado = faq.filter((e) => !e.logado);
  const categoriasAgrupadas = agruparPorCategoria(faqDeslogado);

  return (
    <>
      <div className="d-flex justify-content-center m-5">
        <div style={{width: 900}}>
          {categoriasAgrupadas.map((cat) => (
            <div key={cat.id} className="faq-category-group">
              <div
                className={`faq-category-header ${categoriaAberta === cat.id ? "open" : ""}`}
                onClick={() => toggleCategoria(cat.id)}
              >
                <span>{cat.label}</span>
                <div className="faq-category-right">
                  {categoriaAberta !== cat.id && <span className="faq-hint-cat">Clique Aqui</span>}
                  <span className={`faq-category-icon ${categoriaAberta === cat.id ? "open" : ""}`}>{categoriaAberta === cat.id ? "−" : "+"}</span>
                </div>
              </div>
              <CategoryItems cat={cat} isOpen={categoriaAberta === cat.id} prefix="Deslog" />
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
